import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const workflowDataSlice = createSlice({
  name: "workflowData",
  initialState: {},
  reducers: {
    setWorkflowData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const workflowResourceTypeSlice = createSlice({
  name: "workflowResourceType",
  initialState: "RESOURCE_TYPE_FILE",
  reducers: {
    setWorkflowResourceType: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const reviewDataSlice = createSlice({
  name: "reviewData",
  initialState: {},
  reducers: {
    setReviewData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setWorkflowData } = workflowDataSlice.actions;
export const { setWorkflowResourceType } = workflowResourceTypeSlice.actions;
export const { setReviewData } = reviewDataSlice.actions;

export const workflowData = workflowDataSlice.reducer;
export const workflowResourceType = workflowResourceTypeSlice.reducer;
export const reviewData = reviewDataSlice.reducer;

export default workflowDataSlice.reducer;
